import { Button } from '@mui/material';
import { CategoriesMenu } from './components/CategoriesMenu';

export const renderIcon = (location, width, height) => {
  if (location.iconFile) {
    let tagIconUrl;
    if (location.iconFile.startsWith('http')) {
      tagIconUrl = `${location.iconFile}`;
    } else {
      tagIconUrl = `${process.env.REACT_APP_AWS}/tours/${location.tourId}/tags/icons/${location.iconFile}`;
    }

    return <img width={width || '38px'} height={height || '38px'} src={tagIconUrl} alt={location.title as string} />;
  }

  if (location.custom && location.customIcon !== 'null') {
    const tagIconUrl = location.iconColor
      ? `${process.env.REACT_APP_DOMAIN || 'http://localhost:5030'}/v1/public/icons/${location.customIcon}?hex=${encodeURIComponent(location.iconColor)}&circle=${
          location.whiteCircle
        }`
      : `${process.env.REACT_APP_DOMAIN || 'http://localhost:5030'}/v1/public/icons/${location.customIcon}`;

    return <img width="27px" height="27px" src={tagIconUrl} alt={location.title as string} />;
  }

  return <i className="fa-regular fa-circle-dot" style={{ fontSize: '24px' }} />;
};

export const createInputProps = ({
  isBackgroundVisible,
  clearSearch,
  isSearchBarFocused,
  selectedCategory,
  categories,
  selectCategory,
  searchText,
  actionPathFinished,
  loadingFinished,
  rtl,
}) => {
  return {
    startAdornment: <img src="/navigation/search.svg" alt="" />,
    endAdornment:
      // eslint-disable-next-line no-nested-ternary
      !isBackgroundVisible ? (
        <Button disableElevation sx={{ minWidth: 'unset', width: '44px', height: '44px', borderRadius: '8px' }} variant="contained" color="primary" onClick={clearSearch}>
          <img src="/navigation/burger-menu.svg" alt="buger-menu" />
        </Button>
      ) : isSearchBarFocused ? (
        categories?.length > 2 && searchText.length > 0 && <CategoriesMenu selectedCategory={selectedCategory} rtl={rtl} categories={categories} selectCategory={selectCategory} />
      ) : null,
    sx: {
      background: '#fff',
      height: { xs: '57px', md: '76px' },
      borderRadius: actionPathFinished && !loadingFinished ? '8px 8px 0 0' : '8px',
      border: '1px solid #D0D5DD',
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.05)',
      backdropFilter: 'blur(20.649999618530273px)',
      color: '#101828',
      paddingRight: { xs: '10px', lg: '14px' },
      '& input': {
        fontSize: { xs: '18px', lg: '20px' },
        fontWeight: { xs: '500 !important', lg: '600 !important' },
      },
    },
  };
};
